{
  "title": "Weapons",
  "lead": "Every weapon of the pack's game, from Unity's weapon export. Read-only: weapon fields are tuned live from Tuning.",
  "slot": "Slot",
  "allSlots": "All slots",
  "views": "Views",
  "table": "Table",
  "gallery": "Gallery",
  "summary": "{{game}}: {{count}} weapons, {{ammo}} ammo types",
  "none": "No weapon export for this pack: in Unity run Delve/Content/Export Weapons, then publish it.",
  "newerSchema": "This weapons.json is schema {{schema}}; the workshop reads up to {{max}}.",
  "noRender": "No render: re-export the weapons (Unity: Delve/Content/Export Weapons).",
  "col": {
    "name": "Weapon",
    "slot": "Slot",
    "kind": "Kind",
    "dps": "DPS",
    "damage": "Damage",
    "pellets": "Pellets",
    "fireInterval": "Interval s",
    "range": "Range m",
    "magazine": "Magazine",
    "reloadTime": "Reload s",
    "noise": "Noise m",
    "spread": "Spread °",
    "precisionChance": "Precision %",
    "carriedBy": "Carried by"
  },
  "card": {
    "slot": "Slot",
    "fire": "Fire",
    "damage": "Damage",
    "range": "Range",
    "ammo": "Ammo",
    "magazine": "Magazine",
    "reserve": "Reserve",
    "noise": "Noise",
    "accuracy": "Accuracy",
    "precision": "Precision",
    "carriedBy": "Carried by"
  },
  "v": {
    "damage": "{{damage}} x {{pellets}} every {{interval}} s = {{dps}} DPS",
    "range": "{{range}} m (falloff from {{falloff}} m), pierce {{pierce}}",
    "noAmmo": "none",
    "noMagazine": "no magazine (fires from the reserve)",
    "magazine": "{{count}} rounds, reload {{reload}} s",
    "perRound": " (round by round)",
    "infinite": "infinite",
    "reserve": "starts with {{count}}",
    "regen": ", +1 every {{seconds}} s",
    "silent": "silent",
    "heard": "heard {{meters}} m away",
    "accuracy": "spread {{spread}}°, +{{bloom}}° per shot up to {{max}}°",
    "precision": "{{chance}}% chance, x{{multiplier}} damage",
    "world": "found in the world"
  },
  "sortBy": "Sort by {{column}}"
}
